module.exports = __webpack_public_path__ + "static/media/3-genie-wishes.c2b801cc.gif";